import React from 'react'
import { Button, Col, Row, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import { MdDone, MdClear, MdCreate } from 'react-icons/md'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import PosScheduleForm from '../components/PosScheduleForm'
import { BsPlusSquareFill } from 'react-icons/bs'
import { IconContext } from 'react-icons/lib'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'

class PosScheduleTable extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      role: '',
      modal: false,
      confirmModal: false,
      summaryModal: false,
      isGlobal: '',
      store_id: '',
      scheduleList: [],
      redirect: false,
      selectedId: '',
      selectedData: '',
      slot_summary: [],
    }
  }

  componentDidMount() {
    const user = StorageService.getSession('user_info')
    this.getScheduleList()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data && props.data.role) {
      if (props.data.role !== state.role) {
        return {
          role: props.data.role,
        }
      }
    }
    return null
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      selectedId: id,
    })
  }

  toggleConfirmModal = (name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedId: id,
    })
  }

  toggleSummaryModal = () => () => {
    return this.setState({
      summaryModal: !this.state.summaryModal,
    })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.getScheduleList()
    }
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  getScheduleList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    let fullUrl,
      store_id = ''
    if (!this.props.isGlobal) {
      store_id = this.props.data.store_id
      data.store_id = store_id
      fullUrl = url + ':3001/v1/store/schedule'
    } else {
      fullUrl = url + ':3001/v1/schedule'
    }

    axios
      .post(fullUrl, data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            scheduleList: result.data,
            isGlobal: this.props.isGlobal,
            store_id: store_id,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getslotSummary = schedule_id => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const access = StorageService.getSession('user_access')
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      schedule_id: schedule_id,
    }

    axios
      .post(url + ':3001/v1/store/schedule/slot/summary', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            slot_summary: result.data,
            summaryModal: true,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  delete = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    let data, fullUrl
    if (this.state.isGlobal) {
      data = {
        session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
        schedule_id: this.state.selectedId,
        delete_by: user.email,
      }
      fullUrl = url + ':3001/v1/schedule/delete'
    } else {
      data = {
        session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
        schedule_id: this.state.selectedId,
        store_id: this.props.data.store_id,
        remove_by: user.email,
      }
      fullUrl = url + ':3001/v1/store/schedule/delete'
    }

    axios
      .post(fullUrl, data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: `Schedule ${this.state.isGlobal ? 'deleted' : 'removed'} successfully.`,
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        this.getScheduleList()
      })
      .catch(error => {
        alert(error)
      })
  }

  detail = (id, isStore = false) => {
    this.props.history.push({
      pathname: `/posstore/schedule/` + id,
      state: {
        path: this.props.history.location.pathname,
        store_id: this.state.store_id,
        isStore: isStore,
      },
    })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }

    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />

        <div className="text-right mb-3">
          <div className="ps-btn-group">
            {(this.state.isGlobal || this.state.role == 'Admin') && (
              <Button color="link" onClick={this.toggle('ADD', null)}>
                <IconContext.Provider value={{ color: '#2a2c6b' }}>
                  <BsPlusSquareFill size={25} />
                </IconContext.Provider>
              </Button>
            )}
          </div>
        </div>

        <Table className="ps-table tb-col-7 th-no-wrap ps-responsive-table">
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Advance Day</Th>
              {!this.state.isGlobal && <Th>Type</Th>}
              <Th>Minimum Day</Th>
              <Th>Allow Only Date</Th>
              <Th>Location</Th>
              <Th>Delivery Pickup</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <tbody>
            {this.state.scheduleList.length < 1 && (
              <tr>
                <td colSpan="7">
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>Click the Create button to add new product</span>
                    </div>
                  </div>
                </td>
              </tr>
            )}

            {this.state.scheduleList.length > 0 &&
              this.state.scheduleList.map(item => {
                return (
                  <Tr key={item.schedule_id}>
                    <Td>{item.name}</Td>
                    <Td>{item.advance_days}</Td>
                    {!this.state.isGlobal && <Td>{item.type}</Td>}
                    <Td>{item.advance_min}</Td>
                    <Td>
                      <span className={'ps-indicator ' + (item.allow_onlymod == '1' ? 'on' : 'off')}>{item.allow_onlymod == '1' ? 'Yes' : 'No'}</span>
                    </Td>
                    <Td>{item.location}</Td>
                    <Td>
                      <span className={'ps-indicator ' + (item.pickup == '1' ? 'on' : 'off')}>{item.pickup == '1' ? 'Yes' : 'No'}</span>
                    </Td>
                    <Td>
                      <div className="ps-action-button">
                        {this.state.isGlobal ? (
                          <>
                            <Button className="theme-button theme-button-secondary" onClick={() => this.detail(item.schedule_id)}>
                              View
                            </Button>
                            <Button className="theme-button theme-button-primary-light" onClick={() => this.getslotSummary(item.schedule_id)}>
                              Detail
                            </Button>
                          </>
                        ) : (
                          <>
                            <Button className="theme-button theme-button-secondary" onClick={() => this.detail(item.schedule_id, true)}>
                              View
                            </Button>
                            {this.state.role == 'Admin' && (
                              <Button className="theme-button theme-button-primary-light" onClick={this.toggleConfirmModal(item.name, item.schedule_id)}>
                                Remove
                              </Button>
                            )}
                          </>
                        )}
                      </div>
                    </Td>
                  </Tr>
                )
              })}
          </tbody>
        </Table>

        <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
          <PosScheduleForm history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>Delete Tax</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>
                  Are you sure you want to {this.state.isGlobal ? 'delete' : 'remove'} {this.state.selectedData} ?
                </p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.summaryModal} toggle={this.toggleSummaryModal()} className="modal-lg" centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleSummaryModal()}>Schedule Detail</ModalHeader>
          <ModalBody>
            <Table className="ps-table tb-col-5 th-no-wrap ps-responsive-table">
              <Thead>
                <Tr>
                  <Th>Date</Th>
                  <Th>Current Count</Th>
                  <Th>Start Time</Th>
                  <Th>End Time</Th>
                  <Th>Max Slot</Th>
                </Tr>
              </Thead>
              <tbody>
                {this.state.slot_summary.length < 1 && (
                  <tr>
                    <td colSpan="5">
                      <div className="ps-empty-data">
                        <div className="empty-content">
                          <h4>No data to show</h4>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}

                {this.state.slot_summary.length > 0 &&
                  this.state.slot_summary.map((item, index) => {
                    return (
                      <Tr key={index}>
                        <Td>{item.date}</Td>
                        <Td>{item.current_count}</Td>
                        <Td>{item.starttime}</Td>
                        <Td>{item.endtime}</Td>
                        <Td>{item.max_slot}</Td>
                      </Tr>
                    )
                  })}
              </tbody>
            </Table>
          </ModalBody>
        </Modal>
      </>
    )
  }
}
export default PosScheduleTable
